import { PostHogProvider } from '@posthog/react';
import PropTypes from 'prop-types';
import React from 'react';

const POSTHOG_SDK_DEFAULTS = '2026-05-30';

export function AnalyticsProvider({ children }) {
  return (
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_PROJECT_TOKEN}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        defaults: POSTHOG_SDK_DEFAULTS,
      }}
    >
      {children}
    </PostHogProvider>
  );
}

AnalyticsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
